import { styled } from 'styled-components';

import IconBase from 'components/IconBase';

export const Logo = styled.img`
    height: 3rem;
    width: auto;
`;

export const StyledIcon = styled(IconBase)`
    vertical-align: middle;

    &.sb-theme-black {
        filter: brightness(0) saturate(100%) invert(100%) var(--shadow-on-image);
    }
`;
